import { render, staticRenderFns } from "./Hand-Off.vue?vue&type=template&id=c9f3da9a&scoped=true"
import script from "./Hand-Off.vue?vue&type=script&lang=js"
export * from "./Hand-Off.vue?vue&type=script&lang=js"
import style0 from "./Hand-Off.vue?vue&type=style&index=0&id=c9f3da9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9f3da9a",
  null
  
)

export default component.exports